import { observer } from "mobx-react";
import ShipmentListFiltersStore from "../../../stores/shipments-list-filters-store";
import ShipmentsPageFilterTag from "../shipments-page-filter-tag/shipments-page-filter-tag";
import shipmentsStore from "../../../stores/shipments-store";
import "./active-filters-tags.scss";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { SHIPMENT_STATUS_ENUM } from "../../../../manage-returns/rma-page/rma-types";
import { formatIsoDateRange } from "../../../../../utilities/timezone-utilities";
import currentPortalStore from "../../../../../stores/current-portal-store";

interface IProps {
    shipmentsListFiltersStore: ShipmentListFiltersStore;
}

const ActiveFiltersTags: React.FC<IProps> = observer(({ shipmentsListFiltersStore }) => {

    const {getTranslation} = useDashboardTranslation();
    const scope = 'dashboard-returns-rma-card';
    const tzStore = currentPortalStore.setting?.timezoneStore;

    const selectedShipmentStatusValue = shipmentsListFiltersStore.getSelectedShipmentStatusValue(getTranslation, scope);

    if (!shipmentsListFiltersStore.isFiltersApplied) {
        return null;
    }

    const renderDateRangeTag = () => {
        if (!shipmentsListFiltersStore.createDate) return null;
        return (
            <ShipmentsPageFilterTag
                text={`Created: ${formatIsoDateRange(tzStore, shipmentsListFiltersStore.createDate)}`}
                onClose={() => {
                    shipmentsListFiltersStore.setSelectedCreateDate('');
                    shipmentsListFiltersStore.commitChanges();
                    shipmentsStore.loadPage(1);
                }}
            />
        );
    };

    const renderStatusTag = () => {
        if (!selectedShipmentStatusValue) return null;
        
        return selectedShipmentStatusValue
            .filter(status => status.value !== -1)
            .map(status => (
                <ShipmentsPageFilterTag
                    key={status.value}
                    text={status.label}
                    onClose={() => {
                        const updatedStatuses = shipmentsListFiltersStore.selectedStatus?.filter(
                            s => s !== status.value && s !== SHIPMENT_STATUS_ENUM.VERIFIED
                        );
                        shipmentsListFiltersStore.setSelectedShipmentStatus(
                            updatedStatuses?.length ? updatedStatuses : null
                        );
                        shipmentsListFiltersStore.commitChanges();
                        shipmentsStore.loadPage(1);
                    }}
                />
            ));
    };

    const renderCarrierTag = () => {
        if (!shipmentsListFiltersStore.selectedCarrierIdValue) return null;
        
        return shipmentsListFiltersStore.selectedCarrierIdValue
            .filter(carrier => carrier.value)
            .map(carrier => (
                <ShipmentsPageFilterTag
                    key={carrier.value}
                    text={carrier.label}
                    onClose={() => {
                        const updatedCarriers = shipmentsListFiltersStore.selectedCarrierIdValue?.filter(
                            c => c.value !== carrier.value
                        );
                        shipmentsListFiltersStore.setSelectedCarrierId(
                            updatedCarriers?.length ? updatedCarriers.map(c => String(c.value)) : null
                        );
                        shipmentsListFiltersStore.commitChanges();
                        shipmentsStore.loadPage(1);
                    }}
                />
            ));
    };

    const renderOrderOrRmaCreateDateTag = () => {
        if (!shipmentsListFiltersStore.orderOrRmaCreateDate) return null;
        return (
            <ShipmentsPageFilterTag
                text={`RMA Created: ${formatIsoDateRange(tzStore, shipmentsListFiltersStore.orderOrRmaCreateDate)}`}
                onClose={() => {
                    shipmentsListFiltersStore.setSelectedOrderOrRmaCreateDate('');
                    shipmentsListFiltersStore.commitChanges();
                    shipmentsStore.loadPage(1);
                }}
            />
        );
    };

    const renderDeliveryDateTag = () => {
        if (!shipmentsListFiltersStore.deliveryDate) return null;
        return (
            <ShipmentsPageFilterTag
                text={`Delivered: ${formatIsoDateRange(tzStore, shipmentsListFiltersStore.deliveryDate)}`}
                onClose={() => {
                    shipmentsListFiltersStore.setSelectedDeliveryDate('');
                    shipmentsListFiltersStore.commitChanges();
                    shipmentsStore.loadPage(1);
                }}
            />
        );
    };

    const renderLastUpdateDateTag = () => {
        if (!shipmentsListFiltersStore.lastUpdateDate) return null;
        return (
            <ShipmentsPageFilterTag
                text={`Last Updated: ${formatIsoDateRange(tzStore, shipmentsListFiltersStore.lastUpdateDate)}`}
                onClose={() => {
                    shipmentsListFiltersStore.setSelectedLastUpdateDate('');
                    shipmentsListFiltersStore.commitChanges();
                    shipmentsStore.loadPage(1);
                }}
            />
        );
    };

    return (
        <div className="active-filters-tags">
            {renderStatusTag()}
            {renderCarrierTag()}
            {renderDateRangeTag()}
            {renderOrderOrRmaCreateDateTag()}
            {renderDeliveryDateTag()}
            {renderLastUpdateDateTag()}
        </div>
    );
});

export default ActiveFiltersTags;